<template>
  <div class="carousel_wrap">
      <a href="/" v-for="(item, index) in footerBanner" :key="index" :style="{backgroundImage: `url(${item.image})`}">
      </a>
  </div>
</template>

<script>
export default {
  props: {
    footerBanner: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
.carousel_wrap {
  height: 280px;
 >a {
  display: block;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative
    img {
      width: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 240px;
    left: 268px;
    z-index: 5;
    color: #fff;
    background: rgba(0, 0, 0, 0.1);
    padding: 75px 60px;
    .coName{
      display: flex;
      flex-direction: row;
      align-items: baseline;
      .t1{
        font-family: MicrosoftYaHei;
        font-size: 84px;
        color: #F7DA13;
        line-height: 84px;
        margin-right: 30px;
      }
      .t2{
        font-family: MicrosoftYaHei;
        font-size: 45px;
        color: #FFF;
      }
    }
    .enCoName {
      font-size: 30px;
      color: #FFF;
      margin-top: 19px;
      font-family: MicrosoftYaHei;
    }
    .slogan {
      font-size:25px;
      background: #1E51AD;
      padding: 8px 0;
      text-align: center;
      margin-top: 22px;
      font-family: MicrosoftYaHei;
    }
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
</style>
